import { DataSourcesList } from "./DataSourcesList";

export const DataSources = () => {
  return <DataSourcesList />;
};
